<template>
	<v-container grid-list-xl class="calculatorsList">
			<v-layout row wrap>
        <v-flex lg12 v-if="nonEmptyCalculators.length == 0">No calculators have been setup for this quote.</v-flex>
        <v-flex lg3 v-for="(link, index) in nonEmptyCalculators">
          <img style="max-width: 80%;border-radius: 5px;" src="../../../assets/calculators.jpg" />
          <v-btn style="width: 80%;" @click="fncGoLink(globalModalParams.links[index].link)" color="info">{{ globalModalParams.links[index].name }}</v-btn>
        </v-flex>
        <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
          </div>
        </div>
</v-layout>

	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Swatches from 'vue-swatches';
	import "vue-swatches/dist/vue-swatches.min.css";

	export default {
	  name: 'Settings',
	  components: { Swatches },
	  data () {
			return {
			  search: '',
			  loading: true,
        filterRole: 0,
			  responsibleReps: [],
        headers: [
          { text: '', value: '', width: '15%' },
          { text: 'Responsible Rep', value: 'name', width: '45%' },
          { text: 'Role', value: 'name', width: '40%' },
        ],
        nonEmptyCalculators: []
			};
		},
		methods: {
      fncGoLink(link) {
        window.open(link + '&quoteId=' + this.globalModalParams.quote.id + '&agentId=' + this.objAuthorize.id + '&agentEmail=' + this.objAuthorize.email + '&store=' + this.globalModalParams.quote.store_name + '&customer=' + this.globalModalParams.quote.customer_email, '_blank').focus()
        this.$store.commit('hideModal');
      },
      fncHideModal() {
        /*setTimeout(function() {
          location.reload();
        }, 100)*/
        this.$store.commit('hideModal');
      }
		},
    mounted() {
      for( var l in this.globalModalParams.links ) {
        if( this.globalModalParams.links[l].name != '' && this.globalModalParams.links[l].link != '' ) {
          this.nonEmptyCalculators.push( this.globalModalParams.links[l] );
        }
      }
    },
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
